export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto py-12 md:py-16">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 sm:col-span-1">
            <span className="font-brand text-xl text-background-50">漫蛙漫画</span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              漫蛙漫画网 — 免费韩漫日漫国漫大全，漫画全集高清在线阅读。汇聚海量好看的漫画资源，每日更新，为漫画爱好者打造一站式阅读平台。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><a href="#hero" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">首页</a></li>
              <li><a href="#features" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">平台特色</a></li>
              <li><a href="#index" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">专题合集</a></li>
              <li><a href="#cards" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap">精品推荐</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              <li><span className="text-sm text-background-400 whitespace-nowrap">韩漫</span></li>
              <li><span className="text-sm text-background-400 whitespace-nowrap">日漫</span></li>
              <li><span className="text-sm text-background-400 whitespace-nowrap">国漫</span></li>
              <li><span className="text-sm text-background-400 whitespace-nowrap">漫画大全</span></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-bold text-background-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">暂无具体合作信息</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 漫蛙漫画网. 本站漫画仅供学习交流使用。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500 whitespace-nowrap">韩漫资源</span>
            <span className="text-xs text-background-500 whitespace-nowrap">日漫资源</span>
            <span className="text-xs text-background-500 whitespace-nowrap">国漫资源</span>
          </div>
        </div>
      </div>
    </footer>
  );
}